import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { UserActions } from "redux/actions/settings/UserActions";
import { StoreModel } from "models/StoreModel";
import { LoginUser } from "models/LoginUser";
import { User } from "models/User";
import { TableColumn, Table, TableRow } from "app/components/common/Table";
import { PageContentHeader } from "app/components/common/PageContentHeader";
import { Translations } from "models/Translations";
import Translator from "app/components/common/Translator";

interface Props {
    fetchUsers: typeof UserActions.fetchAllUserData;
    addUser: typeof UserActions.moveToAddUser;
    editUser: typeof UserActions.moveToEditUser;
    deleteUser: typeof UserActions.deleteUser;
    users: User[];
    loginUser: LoginUser;
    translations: Translations;
}

class UsersComp extends React.Component<Props> {
    componentDidMount() {
        if (this.loggedIn() && !this.props.users)
            this.props.fetchUsers(this.props.loginUser.token);
    }

    loggedIn() {
        return this.props.loginUser && this.props.loginUser.token;
    }

    ready() {
        return this.loggedIn() && this.props.users
    }

    setUserData(): TableRow[] {
        let data: TableRow[] = [];
        {
            this.props.users.forEach((user, index) => {
                data.push({
                    dataObject: {
                        id: index + 1,
                        email: user.email,
                        name: user.userName,
                        archivedDate: user.archivedDate
                    }
                })
            })
        }
        return data;
    }

    setColumns(): TableColumn[] {
        // TODO maybe dynamic??
        return [
            {
                header: 'Id',
                accessor: 'id',
            },
            {
                header: 'E-Mail',
                accessor: 'email',
            },
            {
                header: 'User Name',
                accessor: 'name',
            }
        ];
    }

    editUser(id: number) {
        this.props.editUser(id - 1);
    }
    deleteUser(token: string, id: number) {
        this.props.deleteUser(token, this.props.users[id - 1]);
    }

    render() {
        if (!this.ready()) {
            return (
                <div className="c-page__content">
                    <PageContentHeader text="Users" />
                    <Translator text="Loading" />
                </div>
            )
        }
        return (
            <div className="c-page__content">
                <PageContentHeader text="Users" />
                <div className="c-card">
                    <Table
                        addAction={this.props.addUser}
                        editAction={this.editUser.bind(this)}
                        deleteAction={this.deleteUser.bind(this)}
                        editable={true}
                        columns={this.setColumns()}
                        tableData={this.setUserData()}
                        translations={this.props.translations}
                        loginUser={this.props.loginUser}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        users: state.users,
        translations: state.translations
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        fetchUsers: bindActionCreators(UserActions.fetchAllUserData, dispatch),
        addUser: bindActionCreators(UserActions.moveToAddUser, dispatch),
        editUser: bindActionCreators(UserActions.moveToEditUser, dispatch),
        deleteUser: bindActionCreators(UserActions.deleteUser, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UsersComp);